export const dpConfig = {
  http: {
    api: import.meta.env.API_URL,
  },
  support: 'https://tickets.miliboo.io/tickets.php',
  language: {
    fallback: 'en',
  },
  debounce: {
    search: 300,
  },
  env: import.meta.env.MODE,
};

export type DPConfig = typeof dpConfig;
